import {
  hotspotIcon,
  generateCustomIconXml
} from '~js/helpers'

const getMarkerPointXml = function (marker, ath, atv, category, useCustomIcon, index, markerScale, isMarkerPoint, krpanoXOffset) {
  let rx = 0
  let ry = 0
  let rz = 0
  let depth = 1000
  let distorted = false
  let inverserotation = false
  const opacity = marker.opacity ? (marker.opacity / 100) : 0.6
  if (marker.fitGround && atv > 10) {
    rx = 90 - atv
    rz = -marker.spin || 0
    depth = 5 * marker.fitGroundDepth / Math.sin(atv * (Math.PI / 180))
    distorted = true
    inverserotation = true
  } else if (marker.customCoordinate && marker.coordinatePlane !== 0 && marker.rotation) {
    rx = marker.coordinatePlane === 3 ? 90 - atv + (-90 - marker.rotation.x) : atv
    ry = marker.coordinatePlane === 3 ? 0 : -ath + 90 - marker.rotation.y
    rz = marker.rotation.z
    distorted = true
    inverserotation = (marker.coordinatePlane === 3)
  }
  return `<hotspot
    name="markerInfo_${marker.objectId}"
    style="markerInfo"
    scale="0"
    visible="false"
    ath="${ath}"
    atv="${atv - 6}"
    alpha="${opacity}"
    enabled="false"
    zorder="${marker.index}" />
      <hotspot
    name="marker_${marker.objectId}"
    style="${hotspotIcon(marker, useCustomIcon)}"
    scale="${markerScale}"
    ath="${ath}"
    atv="${atv}"
    alpha="${opacity}"
    zorder="${marker.index}"
    distorted="${distorted}"
    inverserotation="${inverserotation}"
    rx="${rx}"
    ry="${ry}"
    rz="${rz}"
    depth="${depth}"
    mipmapping="true"
    enabled="${!marker.disabled}"
    capture="false"
    ${generateCustomIconXml(marker)}
    onclick="on_point_click(${index});prepare_change_scene(panorama_${marker.nextPanoramaId}, ${marker.nextPanoramaId}, 'Hotspot', ${krpanoXOffset - (marker.nextRotation ? marker.nextRotation.y : 0)}, ${isMarkerPoint}, ${ath}, ${marker.objectId});"
    ondown="marker_mousein(${marker.objectId}, ${index}, point);"
    onover="marker_mousein(${marker.objectId}, ${index}, point, ${ath}, ${atv - 6}, ${opacity}, ${category});"
    onout="marker_mouseout(${marker.objectId}, ${index}, point, ${opacity});" />`
}

export default getMarkerPointXml
